// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge-module__container--oY5XV{height:18px;display:flex;align-items:center;justify-content:center;padding:0 10px;border-radius:5px;font-size:10px;text-transform:uppercase;user-select:none}.Badge-module__container--oY5XV.Badge-module__outlined--bXlHS{border:1px solid currentColor}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Badge-module__container--oY5XV`,
	"outlined": `Badge-module__outlined--bXlHS`
};
export default ___CSS_LOADER_EXPORT___;
